/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * CircleCheckIcon - Auto-generated from icon.js
 */
export const CircleCheckIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 0C3.13392 0 0 3.13392 0 7C0 10.8661 3.13392 14 7 14C10.8661 14 14 10.8661 14 7C14 3.13392 10.8661 0 7 0ZM11.2314 5.14428L5.54658 10.6772C5.37552 10.8483 5.09771 10.8483 4.92664 10.6772L2.75479 8.60117C2.58373 8.43011 2.58373 8.1523 2.75479 7.98123C2.92586 7.81017 3.20367 7.81017 3.37474 7.98123L5.2373 9.748L10.6115 4.52434C10.7826 4.35328 11.0604 4.35328 11.2314 4.52434C11.4025 4.69541 11.4025 4.97322 11.2314 5.14428Z"
			fill="current"
		/>
	</svg>
);

export default CircleCheckIcon;
